import axios from 'axios'

import storeConfig from '../../store.config'

const { servicesWorkspace } = storeConfig

const servicesClient = axios.create({
  baseURL: `https://${servicesWorkspace}--decathlonstore.myvtex.com`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default servicesClient
